// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"927":"37086f3f","934":"6ea803bf"}[chunkId] + ".chunk.js";
};